import { eyeIcon } from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import { isDevEnv } from "@excalidraw/common";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";
// KHIYARSA PATCH (Phase 2): cloud accounts/projects menu entries
import { KhiyarsaCloudMenuItems } from "../khiyarsa/cloud/CloudMenuItems";
import { KmdMenuItems } from "../khiyarsa/markdown/ui/MenuItems";
import { AiMenuItems } from "../khiyarsa/ai/MenuItems";

import { saveDebugState } from "./DebugCanvas";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  refresh: () => void;
}> = React.memo((props) => {
  return (
    <MainMenu>
      {/* KHIYARSA PATCH (Phase 2): sign-in / my projects / save-to-cloud */}
      <KhiyarsaCloudMenuItems />
      <MainMenu.Separator />
      <MainMenu.DefaultItems.LoadScene />
      {/* KHIYARSA PATCH (KMD): Markdown → native diagram import */}
      <KmdMenuItems />
      {/* KHIYARSA PATCH (AI Phase 1): natural language → KMD → native diagram */}
      <AiMenuItems />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      {/* KHIYARSA PATCH: "Excalidraw+" and "Sign up" links removed — they
          point to Excalidraw's paid SaaS, unrelated to khiyarsa.com. */}
      <MainMenu.DefaultItems.Socials />
      {isDevEnv() && (
        <MainMenu.Item
          icon={eyeIcon}
          onSelect={() => {
            if (window.visualDebug) {
              delete window.visualDebug;
              saveDebugState({ enabled: false });
            } else {
              window.visualDebug = { data: [] };
              saveDebugState({ enabled: true });
            }
            props?.refresh();
          }}
        >
          Visual Debug
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Preferences />
      <MainMenu.DefaultItems.ToggleTheme allowSystemTheme theme={props.theme} />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
